import { render, staticRenderFns } from "./info-columns.vue?vue&type=template&id=36bf9c02&scoped=true&"
import script from "./info-columns.vue?vue&type=script&lang=js&"
export * from "./info-columns.vue?vue&type=script&lang=js&"
import style0 from "./info-columns.vue?vue&type=style&index=0&id=36bf9c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bf9c02",
  null
  
)

export default component.exports